import { ProductsId } from '@webc/meeseeks-ui-sdk';

export const SET_PRODUCT_QUANTITY = 'SET_PRODUCT_QUANTITY';
export type SetProductQuantityAction = {
  type: typeof SET_PRODUCT_QUANTITY;
  productType: ProductsId;
  quantity: number;
};
export const setProductQuantity = (
  productType: ProductsId,
  quantity: number,
): SetProductQuantityAction => ({
  type: SET_PRODUCT_QUANTITY,
  productType,
  quantity,
});

export const REMOVE_BIKES_FROM_PRODUCT = 'REMOVE_BIKES_FROM_PRODUCT';
type RemoveBikesFromProductAction = {
  type: typeof REMOVE_BIKES_FROM_PRODUCT;
};
export const removeBikesFromProduct = (): RemoveBikesFromProductAction => ({
  type: REMOVE_BIKES_FROM_PRODUCT,
});

export const RESET_ALL_PRODUCTS = 'RESET_ALL_PRODUCTS';
type ResetAllProducts = {
  type: typeof RESET_ALL_PRODUCTS;
};
export const resetAllProducts = (): ResetAllProducts => ({
  type: RESET_ALL_PRODUCTS,
});

export type ProductActions =
  | SetProductQuantityAction
  | RemoveBikesFromProductAction
  | ResetAllProducts;
